import BaseLayer from "./BaseLayer";
import TileImage from "ol/source/TileImage";
import TileGrid from "ol/tilegrid/TileGrid";
import {getResolutionsForMicron, getTilingZoomLevels} from "../utils/map_utils";
import {getPrefixedUrl} from "../../../utils/utils";
import {mapLayerTypes} from "../../../utils/const";
import TileLayer from "ol/layer/Tile";

class TileViewLayer extends BaseLayer {

    id = "tile";
    label = "Final Scan";
    defaultVisible = true;

    componentDidMount() {
        this.init();
        this.layer.get("drew") ? this.setDrawCompleteState() : this.onDrawComplete();
    }

    createLayer = () => {
        let {slide} = this.props;
        let {tile_width, tile_height, img_type, uperpixel} = slide;
        let extent = this.props.map.getView().getProjection().getExtent();
        return new TileLayer({
            id: this.id,
            extent: extent,
            source: new TileImage({
                tileGrid: new TileGrid({
                    extent,
                    origin: [0, extent[3]],
                    resolutions: getResolutionsForMicron(getTilingZoomLevels(slide), uperpixel),
                    tileSize: [tile_width, tile_height],
                }),
                url: getPrefixedUrl(`tiled_raw/{z}/x{x}y{y}.${img_type}`, slide, true),
                wrapX: false,
                crossOrigin: 'anonymous',
            }),
            visible: this.defaultVisible,
            name: mapLayerTypes.STITCHED_LAYER_NAME,
        });
    }

    render() {
        return <div style={{color: '#fff'}}>{this.label}</div>
    }
}

export default TileViewLayer;
